<template>
  <div class="admin-container">
    <!-- 
      1, 用户管理
      2，概要管理
      3，图片管理
      
      这四个页面怎么切换：
      1，使用路由
      2，使用组件
      需要加菜单栏

      使用路由调转
    -->

    <div style="margin: 10px 0">
      <el-input style="width: 200px" placeholder="请输入名称" suffix-icon="el-icon-search" v-model="searchUserNmae"></el-input>

      <el-button class="ml-5" type="primary" @click="loadSearch">搜索</el-button>
      <el-button type="warning" @click="reset">重置</el-button>
    </div>


     <!-- 设置表格宽度为66% -->
 <el-table :data="tableData" stripe>
      <el-table-column
          prop="id"
          label="用户ID"
          sortable
          align="center"
      >
      </el-table-column>
      <el-table-column
          prop="username"
          label="用户名"
          align="center"
      >
      </el-table-column>
      <el-table-column
          prop="realName"
          label="真实姓名"
          align="center"
      >
      </el-table-column>
      <el-table-column
          prop="password"
          label="登陆密码"
          align="center"
      >
      </el-table-column>
      <el-table-column
          prop="phone"
          label="个人电话"
          align="center"
      >
      </el-table-column>
      <el-table-column
          prop="email"
          label="电子邮箱"
          align="center"
      >
      </el-table-column>
      <el-table-column
          prop="workUnit"
          label="工作单位"
          align="center"
      >
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="200" align="center">
        <template #default="scope">
          <el-button @click="handleEdit(scope.row)" type="primary" size="small"  class="edit-button" :icon="Edit">编辑</el-button>
          <el-popconfirm
              title="确定删除吗？" @confirm="handleDel(scope.row.id)">
            <template #reference>
              <el-button size="small" type="danger" class="delete-button" :icon="Delete">删除</el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <!--    引入分页组件-可以根据自己的需要进行定制-->
    <div style="margin: 10px 0">
      <el-pagination
          @size-change="handlePageSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5,10]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
      </el-pagination>
    </div>
   

    <!--    修改信息的提示框-->
    <el-dialog title="用户信息" v-model="dialogVisible" width="30%">
      <el-form :model="form" ref="formId" label-width="120px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" style="width: 70%"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="realName">
          <el-input v-model="form.realName" style="width: 70%"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="form.password" type="password" style="width: 70%"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="form.phone" style="width: 70%"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email" style="width: 70%"></el-input>
        </el-form-item>
        <el-form-item label="工作单位" prop="workUnit">
          <el-input v-model="form.workUnit" style="width: 70%"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
    <span class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import { Delete, Edit } from '@element-plus/icons-vue'
import { 
  ref,
  reactive, 
  getCurrentInstance,
  onMounted,
} from 'vue'
import { ElMessage } from 'element-plus'


export default {

  setup() {

    // currentPage: 1,
    //   pageSize: 5,
    //   total: 10,
    //   tableData: [],
    //   dialogVisible: false,
    //   form: [],

    const { proxy } = getCurrentInstance();

      const currentPage = ref(1);
      const pageSize = ref(5);
      const total = ref(10);
      const tableData = ref([]);
      const dialogVisible = ref(false);
      const form = reactive([]);

      const searchUserNmae=ref();

      onMounted(() => {
        
        list();
      });


  const  handlePageSizeChange = (pageSize2) => {

      pageSize.value = pageSize2
      list()
    };
    const  handleCurrentChange = (pageNum) => {
      currentPage.value = pageNum
      list()
    };
    //查询所有信息
    const list= () =>{
      request.get(`/api/UsersByPage?pageNum=${currentPage.value}&pageSize=${pageSize.value}`)
          .then(res => {
            console.log("res11", res);
          
            tableData.value = res.data.records;
            console.log("res22", tableData);

            total.value = res.data.total;
          })
          .catch(error => {
            console.log("Request failed",error);
          });
    };
    //保存编辑对象
    const save= () =>{
        request.post("/api/update",  {
        id: form.id,
        username: form.username,
        realName: form.realName,
        password: form.password,
        phone: form.phone,
        email: form.email,
        workUnit: form.workUnit
      }).then(
            res => {
              if (res.code === "200") {
               
                ElMessage({
            showClose: true,
            message: res.msg,
            type: "success",
          });
              } else {
               
                ElMessage({
            showClose: true,
            message: res.msg,
            type: "error",
          });
              }
              console.log("res", res)
              dialogVisible.value = false
              list()
            }
        )
 

    };
    const handleEdit = (row) => {
      console.log("row:", row);
      // 编辑逻辑
      //直通通过row获取当前行信息
      dialogVisible.value = true
      proxy.$nextTick(() => { //解决新增有编辑的数据问题
        // 浅拷贝，将row拷贝到formUser
        Object.assign(form, row);
      });
    };
    const handleDel = (id) => {
      console.log('Deleting ID:', id);
      // 删除逻辑
      request.delete(`/api/delete?id=${id}`).then(
          res => {
            if (res.code === "200") {
              
              ElMessage({
            showClose: true,
            message: res.msg,
            type: "success",
          });
            } else {
             
              ElMessage({
            showClose: true,
            message: res.msg,
            type: "error",
          });
            }
            console.log("res", res)
            list()
          }
      )
    };


    const loadSearch=()=> {
      request.get("/api/searchUser", {
        params: {
          username: searchUserNmae.value,
          pageNum: currentPage.value,
          pageSize: pageSize.value,
        }
      }).then(res => {
        console.log("res11", res);
          
            tableData.value = res.data.records;
            console.log("res22", tableData);

            total.value = res.data.total;
      })
    } ;
    const  reset=()=> {
      searchUserNmae.value = "";
      list()
    };
  

    return{
      tableData,
      form,
      dialogVisible,
      total,
      pageSize,
      currentPage,
      list,
      handleEdit,
      handleDel,
      save,
      searchUserNmae,
      handlePageSizeChange,
      handleCurrentChange,
      Delete, Edit,
      loadSearch,reset
    }
    }
  }

 
 
</script>

<style>
.admin-container {
  margin: auto;
  width: 70%;
}

.edit-button {
  color: #409eff; /* 蓝色 */
}

.delete-button {
  color: #f56c6c; /* 红色 */
}

.action-button {
  margin: 0 5px; /* 按钮之间的间距 */
}
</style>
